export default {
  min: {
    title:
      'Levering til din lokation: Beløb der mangler for at nå minimumsordreværdien (subtotal ekskl. leveringsomkostninger og drikkepenge)',
    description:
      'Beklager, du kan ikke bestille endnu. {{name}} har fastsat et minimumsbeløb for ordrer på {{threshold}} (ekskl. leveringsomkostninger)',
  },
  max: {
    title: 'Maksimal ordreværdi for levering nået (i alt ekskl. leveringsomkostninger)',
    description:
      'Din ordre har nået den maksimalt tilladte værdi på {{threshold}} for onlinelevering. For ordrer over dette beløb bedes du kontakte os direkte, så vi kan arrangere leveringen for dig. Tak for forståelsen!',
  },
};
